module.exports = __webpack_public_path__ + "img/question_picture.dde7268a.png";